import { Tag } from "antd";
import CriticalActivityIcon from "components/svg-icons/critical-activity-icon";

function CriticalActivityTag() {
  return (
    <Tag
      className="flex items-center justify-center w-full border-ciq-blue-300 bg-ciq-blue-50 text-ciq-blue-700 rounded-[5px]"
      style={{ height: 24 }}
      icon={<CriticalActivityIcon />}
    >
      Critical Activity
    </Tag>
  );
}

export default CriticalActivityTag;
